// Веб-вклад модуля `audio-recap` — аудио-резюме.
//
// Плитка воркспейса переключает ВИД сцены на аудио, а не запускает генерацию:
// её запускает сама сцена (`requestTopicAudio` без `quotaProcedure`). Поэтому
// `kitKind` здесь не объявлен — дефолтное «добрать вид комплекта» было бы
// вторым путём списания квоты.

import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const audioRecapWebManifest = {
	id: "audio-recap",
	icon: SECTION_ICONS.audioRecap,
	labelKey: "nav.audioSummary",
	tint: SECTION_TINT.audioRecap,
	category: SECTION_CATEGORY.audioRecap,
	routes: ["/audio-recaps"],

	// Баннер РАЗГРАНИЧИВАЕТ три соседних раздела сразу: это не диалог (как у
	// репетитора) и не расшифровка своего звука (как в записи лекции), а
	// синтезированный трек по вашим материалам.
	intro: {
		titleKey: "audio:intro.title",
		bodyKey: "audio:intro.body",
		bulletKeys: ["audio:intro.bullets.0", "audio:intro.bullets.1", "audio:intro.bullets.2"],
	},

	nav: [
		{
			key: "audio-recap",
			to: "/audio-recaps",
			icon: SECTION_ICONS.audioRecap,
			labelKey: "nav.audioSummary",
			order: 80,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM audio_recaps WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "audioRecap",
			icon: SECTION_ICONS.audioRecap,
			tint: SECTION_TINT.audioRecap,
			titleKey: "launcher.audioRecap",
			hintKey: "launcher.audioRecapHint",
			to: "/audio-recaps/new",
			order: 30,
		},
	],

	workspaceTools: [
		{ key: "audio", channel: "listen", icon: SECTION_ICONS.audioRecap, steps: { 1: 10 } },
	],
} satisfies WebModuleManifest;
